<template>
    <div class="chapter_contain">
        <div class="play_box">
            <div class="play_button" @click="clickPlayButton">
                <div class="play_img"></div>
                <div class="play_title">播放全部</div>
            </div>

        </div>

        <div class="chapter_item"
             v-for="(item, index) in listData"
             :key="index"
             @click="clickPlayEpisode(index)"
        >
            <div class="chapter_item_title">{{item.title}}</div>
            <div class="chapter_item_img">
                <img class="img_class" :src="item.cover" alt=""/>
            </div>

        </div>
    </div>

</template>


<script>
import {Toast} from "vant";

export default{
    name: 'audioBookDetailChapter',
    props:{
        resource:{
            type:Object,
            default(){
                return {category: []}
            },
        }
    },
    computed:{
        listData(){
            const r = this.resource
            if(!r || !r.item || !r.item.length) return
            const musics = r.item
            const cover = require('../../../../../public/resource/column/icon_play.png')
            const list = []
            musics.forEach(v => list.push({title:v.title,cover}))
            return list;
        }
    },
    methods:{
        clickPlayButton(){
            if(!this.listData.length){
                Toast.fail("当前专辑中无音频资源")
                return;
            }
            this.$router.push(`/r/music/${this.resource.id}/play`)
        },
        clickPlayEpisode(index){
            this.$router.push({
                path:`/r/music/${this.resource.id}/play`,
                query:{
                    p:index + 1,
                }
            })
        },
    }
}

</script>

<style scoped>
.chapter_contain{
    width:100vw;
    box-sizing: border-box;
}
.play_box{
    width:100vw;
    height:30px;
    display:flex;
    align-items: flex-end;
    padding-left: 4vw;
    box-sizing: border-box;
}
.play_button{
    width:30vw;
    height:20px;
    display:flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
}
.play_img{
    width:0;
    height:0;
    border-width: 8px 0 8px 14px;
    border-color: transparent transparent transparent RGBA(79, 173, 248, 1);
    border-style: solid;
    box-sizing: border-box;

}
.play_title{
    width:calc(30vw - 22px);
    height:20px;
    line-height: 20px;
    font-size: 15px;
    color: black;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

}


.chapter_item{
    width:100vw;
    height:14vw;
    display:flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    border-bottom: 1px solid lightgrey;

}
.chapter_item_title{
    width:40vw;
    height:14vw;
    line-height:14vw;
    padding-left:4vw;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
    font-size: 15px;
}
.chapter_item_img{
    width:14vw;
    height:14vw;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
}

.img_class{
    width:25px;
    height:25px;
    border-radius:15px;
    box-sizing: border-box;
}

</style>
